import { PurchaseDeeplinkQueryParam } from 'src/utils/constants/constants';

import { MultiplePurchaseWizard } from './MultiplePurchaseWizard';

export const MultiplePurchaseWizardModalConfig = {
  children: <MultiplePurchaseWizard />,
  clickOutsideToClose: true,
  deepLinkKey: PurchaseDeeplinkQueryParam,
  deepLinkValue: undefined,
  size: 'slide-in-lg',
};
